import React from 'react';
import PropTypes from 'prop-types';

import UserIconDeprecated from "core/gd-components/icons/user/user-icon-deprecated";

// extends React.Component is required because of reference in parent
export default class UsersMultiselectPopoverOption extends React.Component {

    static propTypes = {
        option: PropTypes.object,

        isHighlighted: PropTypes.bool,
        isSelected: PropTypes.bool,

        onClick: PropTypes.func,
    }

    onClick = () => {this.props.onClick(this.props.option)}

    render() {
        return (
            <div className={Classes('option', 'with-icon-26', {'highlighted': this.props.isHighlighted})} onClick={this.onClick}>
                <div className={Classes("ui5-cb", "s-16", "m-r-10", {selected: this.props.isSelected})}/>
                {!this.props.option.value && <div className="ico i5-users"/>}
                {this.props.option.value && <div className="ico"><UserIconDeprecated userId={this.props.option.value} hint={false} size="26"/></div>}

                <div className="label">{this.props.option.label}</div>
            </div>
        )
    }
}
